import { render, staticRenderFns } from "./NewsManagement.vue?vue&type=template&id=47efc1a3&scoped=true"
import script from "./NewsManagement.vue?vue&type=script&lang=js"
export * from "./NewsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47efc1a3",
  null
  
)

export default component.exports